module.exports = __webpack_public_path__ + "static/media/app-store-logo.f0ce7773.svg";